
import axios from 'axios'

// ACTIONS
import * as filterHomepageActions from './actions'

const mainURL =  process.env.REACT_APP_API_URL; // main route prefix set by environment
const homeUrl = '/v0/persons/home/';

const getProfessionals = (params) => {

  const reqParams = {
    params: { ...params }
  }
  
  return function (dispatch) {
    dispatch(filterHomepageActions.getProfessionals())
    axios.get(`${mainURL}${homeUrl}`, reqParams)
      .then(response => {
        dispatch(filterHomepageActions.getProfessionalsSuccess(response.data.data))
      })
      .catch(response => {
        dispatch(filterHomepageActions.getProfessionalsFailure(response.error))
      })
  }
}

const getProfessional = (url, params) => {

  const reqParams = {
    params: { ...params }
  }
  
  return function (dispatch) {
    dispatch(filterHomepageActions.getProfessionals())
    axios.get(`/v0/persons/${url}/`, reqParams)
      .then(response => {
        dispatch(filterHomepageActions.getProfessionalsSuccess(response.data.data))
        // console.log(response.data.data);
      })
      .catch(response => {
        dispatch(filterHomepageActions.getProfessionalsFailure(response.error))
      })
  }
}

const homepageSkillsRequest = () => {
  
  return function (dispatch) {
    dispatch(filterHomepageActions.getSkills())
    axios.get(mainURL + '/v0/skills/?profile_role=PSIC')
      .then(response => {
        dispatch(filterHomepageActions.getSkillsSuccess(response.data.data))
      })
      .catch(response => {
        dispatch(filterHomepageActions.getSkillsFailure(response.error))
      })
  }
}

const homepageFilter = (params) => {

  return function (dispatch) {
    dispatch(filterHomepageActions.getPersons())
    axios.get(mainURL + '/v0/persons/home/?', { params })
      .then(response => {
        dispatch(filterHomepageActions.getPersonsSuccess(response.data.data))
      })
      .catch(response => {
        console.log('FILTER FAIL')
        // dispatch(filterHomepageActions.getSkillsFailure(response.error));
      })
  }
}

export { homepageSkillsRequest, homepageFilter, getProfessionals, getProfessional }